import {
  PriorAuthorizationStatus,
  PriorAuthorizationType,
} from "@/src/models/documents/prior-authorization/prior-authorization";

export function getAuthorizationStatusLabel(status: PriorAuthorizationStatus | null): string {
  if (!status) return "Other";

  switch (status) {
    case PriorAuthorizationStatus.APPROVED:
      return "Approved";
    case PriorAuthorizationStatus.DENIED:
      return "Denied";
    case PriorAuthorizationStatus.NO_AUTH_REQUIRED:
      return "No Auth Required";
    case PriorAuthorizationStatus.NOT_RECEIVED:
      return "Not Received";
    case PriorAuthorizationStatus.REVIEW_NEEDED:
      return "Review Needed";
    case PriorAuthorizationStatus.ESCALATED:
      return "Escalated";
    case PriorAuthorizationStatus.OTHER:
      return "Other";
    case PriorAuthorizationStatus.PARTIAL_APPROVAL:
      return "Partial Approval";
    case PriorAuthorizationStatus.PENDING:
      return "Awaiting authorization";
    case PriorAuthorizationStatus.FOLLOW_UP:
      return "Follow Up";
    case PriorAuthorizationStatus.PEER_TO_PEER:
      return "Peer to Peer";
    default: {
      const exhaustiveCheck: never = status;

      throw new Error(`Unhandled prior authorization status: ${String(exhaustiveCheck)}`);
    }
  }
}

export function getAuthorizationTypeLabel(type: PriorAuthorizationType | null): string {
  if (!type) return "Other";

  switch (type) {
    case PriorAuthorizationType.PROCEDURE:
      return "Procedure";
    case PriorAuthorizationType.MEDICATION:
      return "Medication";
    case PriorAuthorizationType.IMAGING:
      return "Imaging";
    case PriorAuthorizationType.MEDICAL_SUPPLIES:
      return "Medical Supplies";
    case PriorAuthorizationType.PEER_TO_PEER:
      return "Peer to Peer";
    case PriorAuthorizationType.REFERRAL:
      return "Referral";
    case PriorAuthorizationType.SERVICES:
      return "Services";
    default: {
      const exhaustiveCheck: never = type;

      throw new Error(`Unhandled prior authorization type: ${String(exhaustiveCheck)}`);
    }
  }
}
